import { render, staticRenderFns } from "./WorkflowMaintenanceBatch.vue?vue&type=template&id=0474bf2f"
import script from "./WorkflowMaintenanceBatch.vue?vue&type=script&lang=js"
export * from "./WorkflowMaintenanceBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports